const OtpInput = ({
  otp,
  inputRefs,
  handleOtpChange,
  handleKeyDown,
  handlePaste,
}) => {
  return (
    <div
      className="flex gap-1 sm:gap-3 justify-center my-6"
      onPaste={handlePaste}
    >
      {otp.map((digit, i) => (
        <input
          key={i}
          type="text"
          maxLength={1}
          value={digit}
          ref={(el) => (inputRefs.current[i] = el)}
          className="sm:w-12 sm:h-12 w-9 h-9 border border-gray-400 rounded-md text-center text-xl focus:ring-2 focus:outline-none focus:ring-blue-400"
          onChange={(e) => handleOtpChange(e.target.value, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
        />
      ))}
    </div>
  );
};

export default OtpInput;
